import React from "react";
import {
  Button,
  Dialog as DialogMaterial,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Slide,
  withStyles
} from "@material-ui/core";

import DialogStyle from "./Dialog.style";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const Dialog = props => {
  const {
    title,
    body,
    warningButtonConfirm,
    warningButtonClose,
    isWarningOpen,
    onClickCloseWarning,
    onClickConfirmWarning,
    classes
  } = props;
  return (
    <DialogMaterial
      open={isWarningOpen}
      TransitionComponent={Transition}
      keepMounted
      disableBackdropClick
      disableEscapeKeyDown
      onClose={() => {
        if (onClickCloseWarning) {
          onClickCloseWarning();
        }
      }}
      aria-labelledby="alert-dialog-slide-title"
      aria-describedby="alert-dialog-slide-description"
    >
      <DialogTitle id="alert-dialog-slide-title">
        {title || "Title"}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-slide-description">
          {body}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          onClick={() => {
            if (onClickConfirmWarning) {
              onClickConfirmWarning();
            }
          }}
          className={classes.button}
          color="primary"
        >
          {warningButtonConfirm || "Continue"}
        </Button>
        <Button
          variant="contained"
          onClick={() => {
            if (onClickCloseWarning) {
              onClickCloseWarning();
            }
          }}
          className={classes.buttonCancel}
          color="secondary"
        >
          {warningButtonClose || "Cancel"}
        </Button>
      </DialogActions>
    </DialogMaterial>
  );
};

export default withStyles(DialogStyle)(Dialog);
